import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from './components/MainLayout';
import { DashboardPage } from './pages/DashboardPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { CollaborateursPage } from './pages/CollaborateursPage';
import { RGPDPage } from './pages/RGPDPage';
import { StatsPage } from './pages/StatsPage';
import { SettingsPage } from './pages/SettingsPage';
import LoginPage from './pages/LoginPage';
import { SettingsProvider } from './context/SettingsContext';
import { Toaster } from './components/ui';
import './index.css';

// Capture synchrone du token avant le premier rendu React.
// Sans cela, PrivateRoute lit sessionStorage avant que useEffect ne stocke le token
// et redirige vers /login, ce qui efface le ?token= de l'URL avant qu'il soit lu.
(() => {
  const token = new URLSearchParams(window.location.search).get('token');
  if (token) {
    sessionStorage.setItem('acodoc_token', token);
    window.history.replaceState({}, document.title, window.location.pathname);
  }
})();

function TokenHandler({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

// ── Protection des routes ─────────────────────────────────────────────
// Redirige vers /login si aucun token en session.
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = sessionStorage.getItem('acodoc_token');
  return token ? <>{children}</> : <Navigate to="/login" replace />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SettingsProvider>
      <BrowserRouter>
        <Toaster />
        <TokenHandler>
          <Routes>
            {/* ── Route publique ───────────────────────────────── */}
            <Route path="/login" element={<LoginPage />} />

            {/* ── Routes protégées ─────────────────────────────── */}
            <Route
              element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard"      element={<DashboardPage />} />
              <Route path="/documents"      element={<DocumentsPage />} />
              <Route path="/collaborateurs" element={<CollaborateursPage />} />
              <Route path="/rgpd"           element={<RGPDPage />} />
              <Route path="/stats"          element={<StatsPage />} />
              <Route path="/settings"       element={<SettingsPage />} />
            </Route>
          </Routes>
        </TokenHandler>
      </BrowserRouter>
    </SettingsProvider>
  </React.StrictMode>,
);
